/**
 * 可识别的社交媒体平台
 */
export const SOCIAL_PLATFORMS = ['facebook', 'linkedin', 'youtube', 'twitter'] as const;
